import WorkClient from '../api/workClient';

const searchProducts = (searchTerm: string) => {
  return WorkClient.searchProducts(searchTerm)
};

const ProductCatalogService = {
  searchProducts
};

export default ProductCatalogService;
